import React from 'react';
import { Container, Col, Row, ListGroup, ListGroupItem, Button } from 'reactstrap';
import { RouteComponentProps } from 'react-router-dom';
import { Recipe, Grocery } from 'state/recipe/model';
import pluralize from 'pluralize';

interface Props extends RouteComponentProps<any> {
  groceries: Grocery[]
}

interface State {

}


export default class GroceryList extends React.Component<Props, State> {

  render() {
    return (
      <div>
        <Container>
          <Row>
            <Col md={10}>
              <h1>Grocery List</h1>
            </Col>
          </Row>
          <Row>
            <Col md={10}>
              <ListGroup>
                {this.props.groceries.map((grocery: Grocery, index: number) => {
                  return (
                    <ListGroupItem key={index}>
                      <Row>
                        <Col md={6}>
                          <p>{grocery.unit && pluralize(grocery.unit, grocery.quantity)} {grocery.unit && 'of '}{grocery.name}</p>
                        </Col>
                      </Row>
                    </ListGroupItem>
                  )
                })}
              </ListGroup>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}